import { render } from "./TicketPage.vue?vue&type=template&id=64be18c0&ts=true"
import script from "./TicketPage.ts?vue&type=script&lang=ts"
export * from "./TicketPage.ts?vue&type=script&lang=ts"

import "./TicketPage.vue?vue&type=style&index=0&id=64be18c0&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__